<script type="text/jsx" lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import commonMixin from '@/plans/ZOOM_WHITEBOARD/mixin';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import { BASE_PLAN_SUB_TYPES } from '@/common/constants';

export default {
  mixins: [mixin, commonMixin],
  name: 'ZoomWhiteBoardCart',
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div>
          {this.mx_plans.map((plan) => {
            let title = this.title;
            if (plan.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS) {
              title = this.$t('billing.zoom_whiteboard_plus.title');
            };
            return (
              <div class="opc-cart-item">
                {this.mx_title(title, <AltProratedPlanPrice type={plan.type}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>, plan?.plan_code)}
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                <AltProratedPlanUser type={plan.type}>
                  {this.mx_new_license(plan, plan.cartInfo.selected_number)}
                </AltProratedPlanUser>
                <AltProratedPlanPeriod type={plan.type} />
                {this.mx_edit(plan)}
                {this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
